import React, { useState } from "react"
import { Checkbox, Radio,CircularProgress, FormHelperText } from "@material-ui/core"
import TextField from "@material-ui/core/TextField"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"
import ListItemText from "@material-ui/core/ListItemText"
import { SearchIcon } from "@iconsGallery"
import { Button, OutlinedInput, FormControl } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import styled from "styled-components"
import { useTranslation } from "react-i18next"

const useStyle = makeStyles({
  disableTextHover: {
    "& .MuiListItem-button:hover": {
      background: "transparent !important",
    },
  },
  formControl: {
    "& .MuiFormLabel-root.Mui-focused": {
      color: "var(--primaryColor)",
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "var(--primaryColor)",
      },
    },
  },
  menuCheckbox: {
    "& .MuiCheckbox-colorSecondary.Mui-disabled": {
      color: "gray !important",
    },
  },
  textInput: {
    width: "100%",
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--primaryColor)",
    },
  },
})

function AutocompleteDropdownSingleSelect(props) {
  const {
    label = "",
    fetchData = () => "",
    data: dropdownData,
    filteredItems = [],
    handleDropdownChange = () => "",
    handleSearchTerm = () => {},
    totalDocs = "",
    handleShowMore = () => {},
    searchTerm = "",
    fullWidth = false,
    isLookup = true,
    placeholder = "",
    valueIdentifier = "name",
    error,
    helperText,
    isShowFooter = true,
    isShowSearch = true,
    selectionLimit = 0,
    disableMenuName = "",
    isPlainObj = false,
    showDropdownItems = 2,//minimum number of items to show in dropdown
    checkbox = true,
  } = props || {}

  const isSingleSelect = selectionLimit === 1
  const classes = useStyle()
  const [loading, setLoading] = React.useState(false)
  const [open, setOpen] = useState(false)
  const [selectedItems, setSelectedItems] = React.useState(
     isSingleSelect ? filteredItems || "" : filteredItems || []
  )
  const [searchText, setSearchText] = React.useState(searchTerm)
  const [selectedObj, setSelectedObj] = React.useState([])

  let ref = React.useRef()

  const { t } = useTranslation()
  React.useEffect(() => {
    setSelectedItems(selectedItems)
  }, [selectedItems])

  React.useEffect(() => {
    setSearchText(searchTerm)
  }, [searchTerm])

React.useEffect(() => {
  if (isSingleSelect) {
    setSelectedItems(filteredItems || "")
  } else {
    setSelectedItems(filteredItems || [])
  }
}, [filteredItems, isSingleSelect])

  const ITEM_HEIGHT = 70
  const ITEM_PADDING_TOP = 5
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
    getContentAnchorEl: () => null,
    anchorOrigin: { vertical: "bottom" },
    }
    
    const handleChange = (event) => {
    const value = event.target.value

    // SINGLE SELECT MODE
    if (isSingleSelect) {
        setSelectedItems(value)
        handleDropdownChange(value, label, isPlainObj ? "isPlainObj" : "")
        setOpen(false)
        return
    }

    //MULTI SELECT MODE (existing behaviour improved)
    if (isPlainObj) {
        if (selectionLimit > 0 && value.length > selectionLimit) return
        setSelectedItems(value)
        handleDropdownChange(value, label, "isPlainObj")
    } else {
        if (selectionLimit > 0 && value.length > selectionLimit) return
        setSelectedItems(value)
        handleDropdownChange(value, label)
    }
    }

  const handleSearch = (val) => {
    setLoading(true)
    setSearchText(val)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    handleSearchTerm(val, label)
  }

  return (
    <FormControl className={classes.formControl} fullWidth={fullWidth}>
      <Select
        multiple={!isSingleSelect}
        value={selectedItems}
        onChange={(event) => {
          handleChange(event)
        }}
        defaultValue="none"
        placeholder={t(placeholder)}
        displayEmpty
        input={
          <OutlinedInput
            margin="dense"
            style={{ width: "30vh", height: "36px" }}
          />
        }
        renderValue={(selected) => {
        if (isSingleSelect) {
            if (!selected) return <b>{t(label)}</b>
            return <b>{isPlainObj ? selected?.name : selected}</b>
        }

        if (isPlainObj) {
            if (selected?.length > 0) {
            const remaining = selected.length - showDropdownItems
            return (
                <b>
                {selected.slice(0, showDropdownItems).map(i => i.name).join(", ")}
                {selected.length > showDropdownItems &&
                    ` ${t("and")} ${remaining} ${t("more")}`}
                </b>
            )
            }
            return <b>{t(label)}</b>
        }

        if (selected.length > 0) {
            const remaining = selected.length - showDropdownItems
            return (
            <b>
                {selected.slice(0, showDropdownItems).join(", ")}
                {selected.length > showDropdownItems &&
                ` ${t("AND")} ${remaining} ${t("MORE")}`}
            </b>
            )
        }

        return <b>{t(label)}</b>
        }}
        style={{
          backgroundColor: "transparent",
          height: "38px",
          width: fullWidth ? "100%" : isLookup ? "20vh" : "255px",
        }}
        id="id-detailedTransactionReport-common"
        labelId="id-detailedTransactionReport-common"
        MenuProps={{
          ...MenuProps,
          classes: { paper: "cls-detailedTransactionReport-common-type" },
        }}
        ref={ref}
      >
        {isShowSearch && (
          <>
            <MenuItem
              value=""
              onKeyDown={(e) => e.stopPropagation()}
              style={{
                padding: "5px 10px 10px 10px",
                backgroundColor: "#ffff",
                position: "sticky",
                top: "0px",
                zIndex: "1",
              }}
            >
              <TextField
                variant="outlined"
                size="small"
                placeholder={t("Search")}
                value={searchText}
                InputProps={{
                  endAdornment: (
                    <React.Fragment>
                      <SearchIcon style={{ color: "#CCC" }} />
                    </React.Fragment>
                  ),
                }}
                className={classes.textInput}
                onChange={(event) => {
                  handleSearch(event.target.value.replace(/(\s{2,})/g, " "))
                }}
              />
            </MenuItem>
          </>
        )}
        {loading ? (
          !isShowFooter && (
            <CircularProgress size={30} style={{ margin: "80px" }} />
          )
        ) : dropdownData !== undefined && dropdownData?.length > 0 ? (
          dropdownData.map((name, idx) => (
            <MenuItem
              key={name.id}
              value={isPlainObj ? name : name[valueIdentifier]}
              onClick={() => {
                if (isSingleSelect) {
                const value = isPlainObj ? name : name[valueIdentifier]
                handleChange({ target: { value } })
                }
              }}
              style={{ height: "36px" }}
              disabled={name.name === disableMenuName}
              className={classes.menuCheckbox}
            >
            {checkbox && (
            isSingleSelect ? (
            <Radio
            checked={
            isPlainObj
            ? selectedItems?.[valueIdentifier] === name[valueIdentifier]
            : selectedItems === name[valueIdentifier]
            }
            disabled={name.name === disableMenuName}
            style={{ marginRight: "10%", color: "var(--primaryColor)" }}
            />
            ) : (
            <Checkbox
            checked={
            isPlainObj
            ? selectedItems?.some(i => i[valueIdentifier] === name[valueIdentifier])
            : selectedItems?.includes(name[valueIdentifier])
            }
            disabled={name.name === disableMenuName}
            style={{ marginRight: "10%", color: "var(--primaryColor)" }}
            />
            )
            )}
              <ListItemText primary={name.name} style={{ fontSize: "14px" }} />
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled style={{ height: "30px" }}>
            {t("No Items Found")}
          </MenuItem>
        )}
        {isShowFooter && (
          <>
            {loading ? (
              <CircularProgress size={30} style={{ margin: "80px" }} />
            ) : totalDocs > dropdownData?.length > 0 ? (
              <MenuItem
                style={{ background: "transparent" }}
                value=""
                onKeyDown={(e) => e.stopPropagation()}
              >
                <Button
                  color="primary"
                  style={{ fontWeight: 700 }}
                  onClick={() => {
                    setLoading(true)
                    handleShowMore(label)
                    setTimeout(() => {
                      setLoading(false)
                    }, 2000)
                  }}
                >
                  {t("SHOW_MORE")}
                </Button>
              </MenuItem>
            ) : null}

            <MenuItem
              disabled
              style={{
                background: "#bcb9b9",
                width: "100%",
                display: "flex",
                justifyContent: "end",
                height: "30px",
              }}
            >
              {dropdownData?.length + ` ${t("of")} ` + totalDocs}
            </MenuItem>
          </>
        )}
      </Select>
      {error && (
        <FormHelperText
          error
          style={{ marginLeft: 14, marginRight: 14, marginTop: 4 }}
        >
          {t(helperText)}
        </FormHelperText>
      )}
    </FormControl>
  )
}
export { AutocompleteDropdownSingleSelect }
export default AutocompleteDropdownSingleSelect
